import { DqChatPanelService } from './../samvaad/dq-chat-panel.service';
/**
 * Angular imports.
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

/**
 * Service imports.
 */
import { ConnectionService } from 'ng-connection-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AnalyticsEventService } from '../analytics-event/analytics-event.service';
import { AuthService } from '../auth/auth.service';
import { FunCollectionService } from '../common/common-functions/fun-collection.service';
import { DataStorageService } from '../dataservices/data-storage.service';
import { DocquityAnalyticsService } from '../dataservices/docquity-analytics/docquity-analytics.service';
import { GetService } from '../dataservices/get.service';
import { JwtDecodeService } from '../dataservices/jwt-decode.service';
import { MasterserviceService } from '../dataservices/master-service/masterservice.service';
import { PostApiService } from '../dataservices/post-api.service';
import { UploadfileWithForkService } from '../dataservices/uploadfile-with-fork.service';
import { UserStoryService } from '../dataservices/userStory/user-story.service';
import { DqVideoPlayerService } from './../dataservices/dqVideoPlayer/dq-video-player.service';
import { NewLanguageService } from './../dataservices/new-language/new-language.service';

/**
 * constant imports
 */
import { BRANCH_IDENTIFIER, CREATE_STORY_TYPES, CTA_TYPE, CTA_TYPE_ACTION, NUDGE_BLACKLIST_SCREENS, PRODUCT_TYPE_CONSTANT, RESPONSE_CONSTANT, SCREEN_NAME, STORY_BACKGROUND_CODES, STORY_CREATION_TYPE, STORY_DEFAULT_DURATION, STORY_LOADING_STATE, STORY_TYPES, TEMPLATE_TYPE, USER_STORY_NUDGE, NUMBERS, PRODUCT_TYPE_CONSTANT_NAME, ACTION_TYPE, ACTION_ON } from '../constants/app.constants';
import { MobileWebViewCommunicationService } from '../dataservices/mobileWebViewCommunication/mobile-web-view-communication.service';
import { profileSubmitResponse } from '../onboarding/interface/apiResponse.model';

/**
 * Push Notification Service
 */
import { PushNotificationService } from '../dataservices/push-notification/push-notification.service';
/**
 * Environment imports.
 */
import { environment } from '../../environments/environment';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
import { filter, startWith, takeWhile } from 'rxjs/operators';
import { EVENT_NAME } from '../analytics-event/analytics.constant';
import { NUDGE_PARAMETER_EVENTS, PROFILE_ANALYTICS_SCENERIO, PROFILE_EVENT_NAME } from '../analytics-event/profile2.0-analytics.constant';
import { REUSABLE_COMPONENTS, SAMVAAD_MAINTENANCE } from '../constants/app.constants';
/**
 * Import entire SDK.
 */
import { Analytics } from 'analytics2.0';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const AWS = require('aws-sdk/clients/sqs');

/**
 * MiddleWare Component.
 */
@Component({
  selector: 'app-middle-ware',
  templateUrl: './middle-ware.component.html',
  styleUrls: ['./middle-ware.component.scss']
})
export class MiddleWareComponent implements OnInit, OnDestroy {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public profileData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public masterData: any;
  public countryId = 'en';
  public custome_id: string;
  public loginUserCustomeId: string;
  public isErrorModalShown = false;
  public error_msg = '';
  public deviceInfo = null;
  public flag = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public eventdata: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public profileInfo: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userProfileData: any;
  public user_id: number;
  public masterapi_exeution = true;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public isConnected: any = true;
  public isConnectionModalShown = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public user_nameData: any;
  public isShownWebModal = false;
  public show_feed_post_modal = false;
  public isSkpModalShown = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public skpPointData: any;
  public showSubscribeModal: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public subscribe_obj: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public channelcardcalling: any;
  public backGroundCode = STORY_BACKGROUND_CODES;

  public userStoryNudge = false;

  public storyNudgeType: string;

  public viewStoryThroughProf;

  public nudgeIcon;

  public nudgeHeading: string;

  public nudgeDiscription: string;

  public userStoryNudgeButton: string;

  public customTemplateType;
  /**
   * story creation flags
   */
  public create_user_story: boolean;
  public create_Template_type: number;
  public storyRepostingFileCode: string;

  public templateList: any[] = [];

  public storyCode;

  /**
   * product image for user story
   */
  public productImage: any;

  public productData: any;

  public UserStoryProductType: any;


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public detailId: any;
  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public nudge_data: any;
  public nudge_offset = 1;
  public nudge_action_type = 'action';
  public option = {
    action: 'user active on app',
    product_type: '',
    product_id: '',
    category: '',
  };
  profile_nudge_data;
  public feedDetailObj = {
    is_show: false,
    feed_id: 0,
    mediaIdx: 0,
    ecId: 0,
    isPostedEvent: false
  };
  public delay_time = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public deviceType: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public message: any = null;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  private componentActive = true;
  public isDetailPage = false;

  /**
   * Used to identify the component used to reuse.
   */
  public reusableComponents = REUSABLE_COMPONENTS;
  public isChatWindowState: boolean;

  activeStoryIndex: number;

  /**
   * profile nudges variable
   */
  public toShowProfileNudge = false;

  /**
   * flag variable to perform action or not
   */
  public profileAction = false;
  /**
   * event name for profile nudge
   */
  public profileNudgeEventName: string;
  /**
   * Necessary instances.
   */
  constructor(
    private getSer: GetService,
    private deviceService: DeviceDetectorService,
    private funCollectionService: FunCollectionService,
    private masterService: MasterserviceService,
    private jwtSer: JwtDecodeService,
    private authService: AuthService,
    private router: Router,
    private docquityabalytics: DocquityAnalyticsService,
    public mls: NewLanguageService,
    private connectionService: ConnectionService,
    public dss: DataStorageService,
    private postSer: PostApiService,
    private fileUsFork: UploadfileWithForkService,
    private dqVideoPlayerService: DqVideoPlayerService,
    public dqChatPanelService: DqChatPanelService,
    public userStorySer: UserStoryService,
    private postApi: PostApiService,
    private pushNotification: PushNotificationService,
    private analyticsEventService: AnalyticsEventService,
    private analyticSdk: Analytics,
    public mvc: MobileWebViewCommunicationService
  ) {
    this.subscriptions.add(this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      startWith(this.router)).
      subscribe(() => {
        if (this.router.url.indexOf('/samvaad/list') === -1 ) {
          this.dqChatPanelService.isChatPanelVisible = true;
        }
      }));
    this.getNudgedata();
  }

  /**
   * get event name for triggering profile nudge 
   */
  initializeProfileNudge(): void {
    this.subscriptions.add(this.dss.profileNudgeParamter.subscribe(data => {
      if (data  && this.isNudgeToBeBlackListed()) {
        if (this.toShowProfileNudge === false) {
          this.toShowProfileNudge = true;
          this.getProfileNudgeData(data);
        }
      }
    }))
  }
  /**
   * ngOnInit.
   */
  ngOnInit(): void {
    if(sessionStorage.getItem('logoutType')) {
      sessionStorage.removeItem('logoutType');
    }
    this.preLoad();
    this.initializeProfileNudge();
    this.delay_time = true;
    this.mls.selected_lang = (localStorage.getItem('lang') !== null) ? localStorage.getItem('lang') : 'en';
    this.initData();
    this.preLoad();
    // this.delay_time = true;
    this.mls.selected_lang = (localStorage.getItem('lang') !== null) ? localStorage.getItem('lang') : 'en'; this.epicFunction();
    if (!sessionStorage.getItem('event_session_id')) {
      this.funCollectionService.setSessionId();
    }
    this.pushNotification.requestPermission();
    this.pushNotification.listen();
  }

  /**
   * preLoad.
   */
  preLoad(): void {
    // setTimeout(() => {
    this.delay_time = true;
    // }, 0);
    this.subscriptions.add(this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;

      if (this.isConnected) {
        this.masterService.isOnline = true;
        this.isConnectionModalShown = false;
      } else {
        this.masterService.isOnline = false;
        this.isConnectionModalShown = true;
      }
    }));

    this.subscriptions.add(this.masterService.isConnectionModalShown.subscribe(() => {
      if (this.masterService.isOnline == false) {
        this.isConnectionModalShown = true;
      }
    }));

    this.subscriptions.add(this.masterService.showWebModal.subscribe(data => {
      this.displayObj = data;
      if (this.displayObj.isShow == false) {
        this.resetWebModal();
      }
    }));

    this.subscriptions.add(this.dss.isSkpModalShown.subscribe(data => {
      this.skpPointData = data;
      if (data['isShow'] == true) {
        this.isSkpModalShown = true;
      } else {
        this.isSkpModalShown = false;
      }
    }));

    this.subscriptions.add(this.dss.show_feed_post_modal.subscribe(data => {
      if (data == 1) {
        this.show_feed_post_modal = true;
      } else {
        this.show_feed_post_modal = true;
      }
    }));
    /**
     * to subscribe on create story pop up flag
     */
    this.subscriptions.add(this.dss.create_Story.subscribe(data => {
      if (data == 1) {
        this.create_user_story = true;
        this.customTemplateType = this.dss.create_Template_type;
      }
      if (data == 0) {
        this.create_user_story = false;
      }
    }));

    this.subscriptions.add(this.dss.story_reposting_fileCode.subscribe(data => {
      if (data) {
        this.storyRepostingFileCode = data;
      }
    }));
    this.subscriptions.add(this.dss.templateList.subscribe(data => {
       if (data) {
        this.templateList = data;
       }
    }));
    /**
     * service variable for product image
     */
    this.subscriptions.add(this.dss.create_story_productImage.subscribe(data => {
      this.productImage = data;
    }));
    /**
     * service variable for product data
     */
    this.subscriptions.add(this.dss.create_Story_productData.subscribe(data => {
      if (data) {
        this.productData = data;
      }
    }));
    this.subscriptions.add(this.dss.userStoryNudge.subscribe(data => {
      if (data) {
        this.nudgeIcon = this.dss.storyNudgeIcon;
        this.nudgeHeading = this.dss.storyNudgeHeading;
        this.nudgeDiscription = this.dss.storyNudgeDisc;
        this.storyNudgeType = this.dss.story_nudge_type;
        this.userStoryNudgeButton = this.dss.storyNudgeButton;
        this.userStoryNudge = data;
      }
    }));
    this.subscriptions.add(this.dss.showStoryThroughProfile.subscribe(data => {
      if (data === true) {
        this.openStory(this.dss.viewStoryThroughProfileUuid);
      }
    }));
    this.subscriptions.add(this.dss.showStoryThroughNotification.subscribe(data => {
      if (data === true) {
        this.userStorySer.currentStoryUuid = this.dss.viewStoryThroughNotificationUuid;
        this.openStory(this.dss.viewStoryThroughNotificationUuid);
      }
    }));
    /**
     * receive request for feed detail
     */
    this.subscriptions.add(this.dss.showFeedDetailInModal.subscribe(data => {
      if (data.is_show == true) {
        this.feedDetailObj.is_show = data.is_show;
        this.feedDetailObj.mediaIdx = data.mediaIdx;
        this.feedDetailObj.feed_id = data.feed_id;
        this.feedDetailObj.ecId = data.ecId;
        this.feedDetailObj.isPostedEvent = data.isPostedEvent;

      } else {
        this.resetFeedDetailModal();
      }
    }));

    /**
     * receive request for channel detail
     */
    this.subscriptions.add(this.dss.subscribeChannelCard.subscribe(data => {
      if (data['showSubscribeModal'] == true) {
        this.showSubscribeModal = true;
        this.subscribe_obj = data['docCardObj'];
        this.channelcardcalling = data['callingFrom'];
        this.detailId = data['id'];

      } else {
        this.resetFeedDetailModal();
      }

    }));

    this.custome_id = this.authService.getCustom();
    this.subscriptions.add(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (<any>window).ga('send', 'pageview');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (<any>window).gtag('event', 'page_view', {
          page_path: event.urlAfterRedirects
        });
      }
    }));

    const browserFingerprintId = this.funCollectionService.getFingerPrintUUID();
    const browserUniqueId = this.funCollectionService.getCustomUUID();
    const trackId = localStorage.getItem('trackId') ? localStorage.getItem('trackId') : '';
    const ip = localStorage.getItem('ipAddress');
    const browserInfo = {
      'userAgent': navigator.userAgent,
      'language': navigator.language,
      'colorDepth': screen.colorDepth,
      'deviceMemory': '',
      'hardwareConcurrency': navigator?.hardwareConcurrency ? navigator?.hardwareConcurrency : '',
      'pixelRatio': window.devicePixelRatio,
      'screenResolution': screen.width + 'X' + screen.height,
      'availableScreenResolution': screen.width + 'X' + screen.height,
      'timezoneOffset': new Date().getTimezoneOffset(),
      'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      'sessionStorage': window.sessionStorage,
      'localStorage': window.localStorage,
      'indexedDb': window.indexedDB,
      'addBehavior': '',
      'openDatabase': '',
      'cpuClass': '',
      'platform': navigator.platform,
      'doNotTrack': navigator?.doNotTrack ? navigator?.doNotTrack : '',
      'plugins': navigator.plugins,
      'canvas': '',
      'webgl': '',
      'webglVendorAndRenderer': '',
      'adBlock': '',
      'hasLiedLanguages': '',
      'hasLiedResolution': '',
      'hasLiedOs': '',
      'hasLiedBrowser': '',
      'touchSupport': '',
      'fonts': '',
      'fontsFlash': '',
      'audio': '',
      'enumerateDevices': navigator.mediaDevices?.enumerateDevices ? navigator.mediaDevices?.enumerateDevices : '',
      'longitude': '',
      'lattitude': ''
    };
    this.subscriptions.add(this.postApi.recordBrowserDetails(browserFingerprintId, browserUniqueId, trackId, ip, browserInfo).subscribe(() => {
      // No Code
    }, () => {
      // No Code
    })
    );
  }

  /**
   * Reload page
   */
  Reload_page(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    window.location.reload();
  }

  /**
   * epic Function
   */
  epicFunction(): void {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    environment.device_info = this.deviceInfo;
    if (this.deviceService.isMobile() == true) {
      this.deviceType = 'mobile';
    }
  }

  /**
   * init Data
   */
  initData(): void {
    if (localStorage.getItem('token') == null) {

      if (this.mvc.checkSurveyRequestedFrom()) {
        this.flag = true;
        return;
      }
      if (!this.mvc.checkAuthenticByPass() && !this.authService.isAuthenticated()) {
        this.router.navigateByUrl('login/input-mobile');
      }

      const absurl = window.location.href.slice(window.location.href.indexOf('#') + 1);
      let absurl2 = absurl.split('/course-detail/');

      if (absurl2.length < 2) {
        absurl2 = absurl.split('/detail/');
      }

      if (absurl2.length >= 2) {
        let ptype = absurl2[0];
        if (ptype == '/web') {
          ptype = '1';
        }

        if (ptype == '/cme') {
          ptype = '8';
        }

        if (ptype == '/channel') {
          ptype = '10';
        }

        if (ptype == '/event') {
          ptype = '7';
        }

        if (ptype == '/journal') {
          ptype = '3';
        }

        if (ptype == '/clinical') {
          ptype = '3';
        }
        const pid = absurl2[1];

        window.location.href = environment.baseUrls.webSiteUrl + '/#/login?ptype=' + ptype + '&pid=' + pid;
        return;
      }
    } else {
      if (this.mvc.checkSurveyRequestedFrom()) {
        this.flag = true;
        return;
      }
      // const lang = localStorage.getItem('lang');
      this.flag = false;
      this.masterapi_exeution = true;
      this.subscriptions.add(this.masterService.getMasterDetail().subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          this.masterData = data;
          if (this.masterData.status == 1) {
            this.masterService.masterApiData = this.masterData;
            this.flag = true;
            this.loginUserCustomeId = this.authService.getbyName('profile_obj');
            this.callLoginUserProfile();
          } else if (this.masterData.status == 0) {
            this.funCollectionService.errorHandeler(data);
          }
        }, () => {
          this.masterapi_exeution = false;
          this.retryMasterApi();
        });
      }));
    }
  }

  /**
   * retry Master Api
   */
  retryMasterApi(): void {
    this.subscriptions.add(this.masterService.getMasterDetail().subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        this.masterData = data;

        if (this.masterData.status == 1) {
          this.masterService.masterApiData = this.masterData;
          this.loginUserCustomeId = this.authService.getbyName('profile_obj');
          this.callLoginUserProfile();
        } else if (this.masterData.status == 0) {
          this.funCollectionService.errorHandeler(data);
        }
      }, () => {
        this.retryMasterApi();
      });
    }));
  }

  /**
   * httpError Handeler
   */
  httpErrorHandeler(): void {
    // No Code
  }

  /**
   * httpError Handeler
   */
  ErrorHandler(Err_msg): void {
    this.isErrorModalShown = true;
    this.error_msg = Err_msg;
  }

  /**
   * reset ErrorModal
   */
  resetErrorModal(): void {
    this.isErrorModalShown = false;
  }

  /**
   * set Docquity Analytic
   */
  setDocquityAnalytic(): void {
    const d = new Date();
    const difference = d.getTime() - this.docquityabalytics.set_time;
    const minutesDifference = Math.floor(difference / 1000 / 60);
    if (minutesDifference > 15) {
      this.docquityabalytics.set_time = d.getTime();
      this.funCollectionService.setSessionId();
    }

    const sessiontime = { 'start_time': d.getTime(), 'end_time': d.getTime() };
    let location;
    {
      location = { 'latitude': '', 'longitude': '', 'local': '', 'time_zone': d.getTimezoneOffset() };
    }

    this.eventdata = {
      event_name: this.option.action,
      product_type: this.option.product_type,
      product_type_id: this.option.product_id,
      session_id: this.docquityabalytics.event_session_id,
      local_id: '0',
      screen_name: this.option.category,
      user_id: this.user_id,
      untrack_user_identifier: '',
      session_time: sessiontime,
      location: location
    };
    this.docquityabalytics.all_event.push(this.eventdata);
    this.docquityabalytics.docquityAnalytics(this.docquityabalytics.all_event)
      .pipe(takeWhile(() => this.componentActive))
      .subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          if (data['status'] == 1) {
            this.docquityabalytics.all_event = [];
          }
        });
      });
  }

  /**
   * reset Connection Modal
   */
  resetConnectionModal(): void {
    this.isConnectionModalShown = false;
  }

  /**
   * call Login User Profile
   */
  callLoginUserProfile(): void {
    this.subscriptions.add(this.masterService.getProfile()
      .subscribe(rootObject => {
        this.masterapi_exeution = false;
        // this.flag = true;

        if (rootObject['status'] === 1) {
          this.dss.user_profile_data = rootObject['data'];
          this.dss.qb_user_credential.login = this.dss.user_profile_data.profile.jabber_name;
          this.dss.qb_user_credential.password = this.dss.user_profile_data.profile.chat_password;
          this.dss.profile_speciality = this.dss.user_profile_data?.speciality;
        } else if (rootObject['status'] === 0 && rootObject['code'] == 2000) {
          this.funCollectionService.errorHandeler(rootObject);
        }
      }));
  }

  /**
   * reset Web Modal
   */
  resetWebModal(): void {
    if (
      this.displayObj.display_section == 'verify_step1' ||
      this.displayObj.display_section == 'verify_step2' ||
      this.displayObj.display_section == 'verificationSuccess' ||
      this.displayObj.display_section == '') {
      this.dss.suggAssList = [];
      this.dss.selected_suggAssList = [];
    }
    this.displayObj = {
      isShow: false,
      display_section: '',
      data: [],
      errObj: []
    };
    if (this.displayObj.isShow == false) {
      this.masterService.resetWebModal.next(true);
      return;
    }
    this.masterService.showWebModal.next(this.displayObj);
  }

  /**
   * reset Feed Post Modal
   */
  resetFeedPostModal(): void {
    this.show_feed_post_modal = false;
  }
  /**
   * story creation dialog close
   */
  resetStoryCreation(): void {
    this.dss.story_reposting_fileCode.next(null);
    this.storyRepostingFileCode = null;
    this.dss.user_story_productType = null;
    this.dss.user_story_productTypeId = null;
    this.dss.create_Story_productData.next(null);
    this.dss.create_story_productImage.next(null);
    this.dss.templateRepost = false;
    this.dss.tag_user_list = [];
    this.dss.userType = '';
    this.userStorySer.storyTagList = [];
    this.dss.templateList.next('');
    this.create_user_story = false;
    this.dss.create_Story.next(0);
  }
  /**
   * create story through nudge
   */
  createStoryThroughNudge(event): void {

    if (this.dss.user_profile_data.profile.permission != 'all') {
      this.funCollectionService.assignAssociation('');
      this.userStoryNudge = false;
      return;
    }
    this.closeStoryNudge(event);
    this.dss.create_Story.next(true);
  }
  hideNudge(event): void {
    this.resetStoryCreation();
    this.closeStoryNudge(event);
  }
  /**
   * reset Feed Detail Modal
   */
  resetFeedDetailModal(): void {
    this.feedDetailObj = {
      is_show: false,
      feed_id: 0,
      mediaIdx: 0,
      ecId: 0,
      isPostedEvent: false
    };
  }

  openStory(uuid: string): void {
    if (this.dss.userType === STORY_TYPES.PHARMA) {
      this.userStorySer.currentStoryUuid = 'channel' + this.dss.storyProfileChannelId ;
      this.storyStateManage(uuid, this.dss.storyProfileChannelId);
    }
    else {
      this.userStorySer.currentStoryUuid = uuid;
      this.storyStateManage(uuid);
    }
    this.viewStoryThroughProf = true;
  }
  storyStateManage(uuid, channelId?): void {
    if (this.dss.currentStoryCode) {
      // const index = this.userStorySer.getStoryIndexForStoryCode(this.dss.currentStoryCode, data.lc.list);
    }
    let key = '';
    if (this.dss.userType === STORY_TYPES.PHARMA) {
      key = 'channel' + channelId;
    }
    else {
      key = uuid;
    }
    this.userStorySer.storyLoadingState.set(key, STORY_LOADING_STATE.PENDING);
    const userType = this.dss.userType;
    this.subscriptions.add(this.getSer.getUserStoryDetail('1',uuid, userType).subscribe(data => {
      if (data.lc) {
        for (const i in data.lc?.list) {
          this.userStorySer.fileCodeUrlMap.set(data.lc?.list[i].fileCode, data.lc?.list[i].fileUrl);
          data.lc.list[i].duration = STORY_DEFAULT_DURATION;
        }
        this.userStorySer.storyLoadingState.set(key, STORY_LOADING_STATE.SUCCESS);
        const dataValue = {value: data.lc, expired: false};
        this.userStorySer.UserStoryDetail.set(key, dataValue);
        if (data.lc.channelId != 0) {
          this.userStorySer.UserStoryDetail.set(data.lc.uuid, dataValue);
          this.userStorySer.storyLoadingState.set(data.lc.uuid, STORY_LOADING_STATE.SUCCESS);
          if (this.dss.userType === null) {
            const value = 'channel' + data.lc.channelId;
            this.userStorySer.UserStoryDetail.set(value, dataValue);
            this.userStorySer.storyLoadingState.set(value, STORY_LOADING_STATE.SUCCESS);
          }
        }
        this.userStorySer.storyDataChanged.next(2);
      }
      }));

  }
  /**
   * close story nudge
   */
  closeStoryNudge(event): void {
    if (event) {
      if (event === USER_STORY_NUDGE.is_story_introduction_enabled || event === USER_STORY_NUDGE.is_story_first_like_enabled) {
        const key = event === USER_STORY_NUDGE.is_story_introduction_enabled ? USER_STORY_NUDGE.story_self_intro : USER_STORY_NUDGE.story_like;
        this.subscriptions.add(this.postSer.logTutorialView(key).subscribe(data => {
          if (data) {
            if (event === USER_STORY_NUDGE.is_story_tutorial_enabled) {
              this.dss.isStoryTutorialEnabled.next(0);
            }
            else if (event === USER_STORY_NUDGE.is_story_introduction_enabled) {
              this.dss.isStoryIntroductionEnabled = 0;
            }
          }
        }));
      }
    }
    this.userStoryNudge = false;
  }
  /**
   * log story view
   */
  logViewStory(event): void {
    //
  }
  closeStories(): void {
    this.viewStoryThroughProf = false;
    this.dss.viewListByDefault = false;
    this.userStorySer.resetStoryView();
    document.getElementsByTagName('BODY')[0].classList.remove('overflow-hidden', 'position-fixed');
  }
  /**
   *
   * @param videoUrl fetch video as blob
   * @returns
   */
  async  fetchVideoAsBlob(videoUrl: string): Promise<Blob> {
    const response = await fetch(videoUrl);
    const videoData = await response.blob();
    return videoData;
  }
  /**
   * get video thumbnail
   */
  async getVideoThumbnail(videoFile): Promise<any> {
    return await this.fileUsFork.generateThumbnail(videoFile).then(data => {
        data = JSON.parse(data);
        return data;
    });
  }
  /**
   * Get the current time in string.
   */
  getTimeString(): string {
    return new Date().getTime().toString();
  }
  /**
   * stories redirection
   */
  async onCtaClick(event: any): Promise<void> {
    document.getElementsByTagName('BODY')[0].classList.remove('overflow-hidden','position-fixed');
    if (event.target.ctaType ===CTA_TYPE.PRIMARY  && event.target.type !== STORY_TYPES.TEMPLATE) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY, event.repostingData.storyCode, SCREEN_NAME.STORY_PLAY, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.STORY_CTA, null )
    }
    if (event.target?.type === CTA_TYPE_ACTION.DEEPLINK || event.target?.type === CTA_TYPE_ACTION.REPOST) {
      if (event.target?.type === CTA_TYPE_ACTION.DEEPLINK) {
        window.location.href = event.target.url;
      }
      else if (event.target?.type === CTA_TYPE_ACTION.REPOST) {
        this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY, event.repostingData.storyCode, SCREEN_NAME.STORY_PLAY, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_STORY, null )
        if (this.dss.user_profile_data.profile.permission != 'all') {
          this.funCollectionService.assignAssociation('');
          this.closeStories();
          return;
        }
        this.dss.storyDuration = event.repostingData.duration;
        this.dss.story_creating_type = STORY_CREATION_TYPE.REPOST_STORY;
        this.dss.StoryFileType = event.repostingData.fileType;
        this.dss.storyRepostCta = event.repostingData.cta;
        if (event.repostingData.storyType === STORY_TYPES.PHARMA || event.repostingData.storyType === STORY_TYPES.PHARMAREPOST) {
          this.dss.storyType = CREATE_STORY_TYPES.PHARMAREPOST;
          this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
          this.dss.storyRepostCode = event.repostingData.storyType === STORY_TYPES.PHARMA ? event.repostingData.storyCode : event.repostingData.pharmaRepostStoryCode;
        }
        else if (event.repostingData.storyType === STORY_TYPES.TEMPLATE) {
          this.dss.storyType = STORY_TYPES.TEMPLATE;
          this.dss.templateRepost = true;
          this.dss.templateValue = event.repostingData.templateValue;
        }
        else {
          this.dss.storyType = CREATE_STORY_TYPES.REPOST;
          this.dss.user_story_productType = event.repostingData.productType;
          this.dss.user_story_productTypeId = event.repostingData.productTypeId;
          this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
        }
        if (event.repostingData.fileCode) {
          this.dss.story_reposting_fileCode.next(event.repostingData.fileCode);
        }
        this.closeStories();
        this.dss.create_Story.next(true);
      }
    }
    else  {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY, event.repostingData.storyCode, SCREEN_NAME.STORY_PLAY, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.TEMPLATE_SELECTION, null )
      if (this.dss.user_profile_data.profile.permission != 'all') {
        this.funCollectionService.assignAssociation('');
        this.closeStories();
        return;
      }
      // this.isStoriesOpen = false;
      this.dss.story_template_code.next(event.target?.id);
      this.userStorySer.StoryshowLoader.next(false);
      this.dss.StoryFileType = STORY_TYPES.IMAGE;
      this.subscriptions.add(this.getSer.getTemplateList(event.target?.id).subscribe(async data => {
        if (data?.lc) {
          this.dss.templateList.next(data.lc);
          // await this.userStorySer.mapFileCodeWithUrl(data.lc, "code");
          for (const elem of data.lc) {
            this.userStorySer.fileCodeUrlMap.set(elem.code, elem.fileUrl);
          }
          this.dss.create_Template_type = (TEMPLATE_TYPE.TEMPLATE);
          this.dss.storyType = CREATE_STORY_TYPES.TEMPLATE;
          this.dss.templateValue = event.target?.id;
          this.userStorySer.StoryshowLoader.next(false);
          this.closeStories();
          this.dss.create_Story.next(true);
          if (event.repostingData.fileCode) {
            // this.dss.story_reposting_fileCode.next(event.repostingData.fileCode);
          }
        }
      }));

    }
    return;
  }
  /**
   *
   * @param event profile header redirection
   */
  headerRedirection(event): void {
    if (event.userType ===STORY_TYPES.PHARMA) {
      this.funCollectionService.navigateToChannelDetail(event.targetId);
    }
    else {
      this.funCollectionService.navigateToUserProfie(event.targetId);
    }
    this.closeStories();
  }
  onStoryChange(event): void {
    this.userStorySer.endAnimation.next(true);
  }
  onAllStoriesEnd(event): void {
    this.closeStories();
    this.dss.currentStoryCode = '';
    this.userStorySer.resetStoryView();
  }
  /**
   * get story data
   */
  async getStoryDetail(uuid): Promise<void> {
    return new Promise(async (resolve, reject) => {
      this.subscriptions.add(await this.getSer.getUserStoryDetail('1',uuid).subscribe(data => {
        if (data?.lc) {
          this.userStorySer.mapFileCodeWithUrl(data.lc?.list, 'fileCode');
          this.userStorySer.storyLoadingState.set(uuid, STORY_LOADING_STATE.SUCCESS);
          this.userStorySer.UserStoryDetail.set(uuid, data.lc);
          this.userStorySer.storyDataChanged.next(2);
          resolve();
        }
        else if (data?.status === 204) {
         reject();
        }
      }));
    });
  }

  /**
   * 
   * @param event get profile nudge data
   */
  getProfileNudgeData(event): void {
    this.getSer.getProfileNudgeData(event).subscribe(data => {
      if (data) {
        if (data.lc) {
          this.profile_nudge_data = data.lc;
          this.profileNudgeEventName = event;
          document.getElementsByTagName('BODY')[0].classList.add('overflow-hidden','position-fixed');
        }
        else {
          this.profile_nudge_data = null;
        }
      }
    });
  }
  /**
   * function to blacklist or pass the nudge to be rendered on the basis screen name
   */
  isNudgeToBeBlackListed(): boolean {
    if (NUDGE_BLACKLIST_SCREENS[this.dss.currentScreenName]) {
      this.toShowProfileNudge = false;
      this.profile_nudge_data = null;
      document.getElementsByTagName('BODY')[0].classList.remove('overflow-hidden','position-fixed');
      return false;
    }
    return true;
  }

  sendProfileAnalytics(event): void {
    this.analyticsEventService.sendAnalytics(event.eventData.event_name,
      0,
      0,
      event.eventData.screen_name,
      event.eventData.start_time,
      event.eventData.end_time,
      null
    );
  }

  /**
   * get Nudge data
   */
  getNudgedata(): void {
    this.getSer.getNudgeData(this.nudge_offset, this.nudge_action_type)
      .pipe(takeWhile(() => this.componentActive))
      .subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          if (data.status == 1) {
            this.setWebinarContinueWatchSpan(data?.data?.webinar_continue_watch_span);
            this.dqVideoPlayerService.isPipEnabled = data?.data?.is_pip_enabled;
            if (this.dqVideoPlayerService.isPipEnabled) {
              this.dqVideoPlayerService.isPipTutorialEnabled.next(data?.data?.is_pip_tutorial_enabled);
            }
            this.dqVideoPlayerService.isTextToSpeechTutorialEnabled.next(data?.data?.is_text_to_speech_tutorial_enabled);
            this.dss.isTagUserTutorialEnabled.next(data?.data?.is_tag_user_tutorial_enabled);
            if(data?.data?.chat?.samvaad?.maintenance === SAMVAAD_MAINTENANCE.YES){
              this.dqChatPanelService.isChatMaintenance = true;
              this.funCollectionService.isChatMaintenance = true;
            }
            if (!this.isChatWindowState) {
              this.isChatWindowState = true;
              if (data?.data?.chat?.window_state) {
                this.dqChatPanelService.expandChat.next(true);
              } else {
                this.dqChatPanelService.expandChat.next(false);
              }
              this.dss.chatWindowState.next(data?.data?.chat?.window_state);
            }
            this.nudge_data = data.data;
            this.dss.background_api_document_flag = this.nudge_data.document_status;
            this.dss.tooltip_list = data.data.tooltip_list;
            this.dss.exploreNewTags = this.nudge_data.new_tags;
            this.dss.backgroundCommunity = this.nudge_data.community;
            this.dss.communityBackgroundActive.next(this.nudge_data.community);
            this.dss.dynamicAppLogo = data.data.app_icon_identifier;
            this.dss.reposTooltip = data?.data?.is_repost_tutorial_enabled;
            this.dss.isRepostEnable = data?.data?.is_repost_enabled;
            this.dss.uuid = data?.data?.profile?.uuid;
            this.dss.isCertificateShareEnabled = data?.data?.user_story?.is_story_cme_certificate_share_enabled;
            this.dss.isWebinarShareEnabled = data?.data?.user_story?.is_story_webinar_register_enabled;
            this.dss.isPostSuccessShareEnabled = data?.data?.user_story?.is_story_post_success_enabled;
            this.dss.isStoryLikeShareEnabled = data?.data?.user_story?.is_story_first_like_enabled;
            this.dss.isStoryIntroductionEnabled = data?.data?.user_story?.is_story_introduction_enabled;
            this.dss.isStoryTutorialEnabled.next(data?.data?.user_story?.is_story_tutorial_enabled);
            if (data.data.profile) {
              this.dss.profileDeleteFlag = data.data.profile.is_profile_deletion_enable;
            }
          }
        });
      });
  }
  /**
   * function to set webinar continue watch span
   * @param days 
   */
  setWebinarContinueWatchSpan(days:number):void{
    localStorage.setItem("WebinarWatchSpan",days.toString());
  }

  /**
   * function to get event name
   */
  getEventName(nudgeParameter: string, actionType: string): string {
    return NUDGE_PARAMETER_EVENTS[nudgeParameter][actionType];
  }
  /**
   * perform profile actions
   */
  performAction(event: {body: any, action: string, screenName: string, startTime: string, nudgeParameter:string, redirection: string }): void {
    if (this.profileAction === true) {
      return;
    }
    this.profileAction = true;
    this.subscriptions.add(this.postSer.submitProfilData(event.body, event.action).subscribe(data => {
      this.profileAction = false;
      if (data) {
        if (data.status === NUMBERS.TWO_HUNDRED || data.status === NUMBERS.TWO_HUNDRED_ONE) {
          if (data.body.mc === RESPONSE_CONSTANT.S102000) {
            let eventName;
            if (event.action === PROFILE_ANALYTICS_SCENERIO.SUBMIT) {
              eventName = PROFILE_EVENT_NAME[this.getEventName(event.nudgeParameter, PROFILE_ANALYTICS_SCENERIO.SUBMIT)];
            }
            if (event.action === PROFILE_ANALYTICS_SCENERIO.CLOSE) {
              eventName = PROFILE_EVENT_NAME[this.getEventName(event.nudgeParameter, PROFILE_ANALYTICS_SCENERIO.CLOSE)]
            }
            if (event.action === PROFILE_ANALYTICS_SCENERIO.DECLINE) {
              eventName = PROFILE_EVENT_NAME[this.getEventName(event.nudgeParameter, PROFILE_ANALYTICS_SCENERIO.DECLINE)]
            }
            if (eventName) {
              const analyticsData = {
                event_name: eventName,
                product_type: 0,
                product_type_id: 0,
                screen_name: event.screenName,
                start_time: event.startTime,
                end_time: this.getTimeString(),    
            };
            this.sendProfileAnalytics({eventData: analyticsData, isHxrCall: false, passScreenName: false});
            }
            const exitEventName = PROFILE_EVENT_NAME[this.getEventName(event.nudgeParameter, PROFILE_ANALYTICS_SCENERIO.EXIT)];
            if (exitEventName) {
              const analyticsData2 = {
                event_name: exitEventName,
                product_type: 0,
                product_type_id: 0,
                screen_name: event.screenName,
                start_time: event.startTime,
                end_time: this.getTimeString(),    
            };
            this.sendProfileAnalytics({eventData: analyticsData2, isHxrCall: false, passScreenName: false});
          }
          this.toShowProfileNudge = false;
          this.profile_nudge_data = null;
          document.getElementsByTagName('BODY')[0].classList.remove('overflow-hidden','position-fixed');
          if (event.redirection.length > 0) {
            this.redirections(event.redirection);
          }
          }
        }
      }
    }));
  }
  /**
   * 
   * @param identifier function for redirection
   */
  redirections(identifier: string) {
    if (Object.values(BRANCH_IDENTIFIER).includes(identifier)) {
      this.funCollectionService.redirectOnSection(identifier, null);
    }  
    else if (identifier.indexOf('http') !=-1) {
      window.open(identifier);
    }
  }

  /**
   * get Chat Credential
   */
  getChatCredential(): void {
    this.subscriptions.add(this.postSer.getQBCrediential().subscribe(data => {
      if (data['posts'].status == 1) {
        this.dss.qb_user_credential.login = data['posts'].data.jabber_name;
        this.dss.qb_user_credential.password = data['posts'].data.jabber_password;
        if (this.dss.qb_user_credential.password != '') {
          // const x = { login: data['posts'].data.jabber_name, password: data['posts'].data.jabber_password };
        }
      }
    }));
  }

  /**
   * reset SubscribeModal
   */
  resetSubscribeModal(): void {
    this.showSubscribeModal = false;
  }

  /**
   * has Subscribed
   */
  hasSubscribed(): void {
    this.dss.subscribeFeedChannelCard.next('feedChannelSubscribed');
  }

  /**
   * close open access restriction pop up
   */
  closeOpenAccessRestrictionNudge(): void {
    this.mls.toShowNologinRestrictionPopUp = false;
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.componentActive = false;
  }
}
